var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMailGray16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A14F1C7-62BB-43E0-9E13-452D85AB438F_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-784.000000, -544.000000)",
    fill: "#C1C1C1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(752.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(32.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,5 L1,5 C0.447,5 0,5.447 0,6 L0,16 C0,16.552 0.447,17 1,17 L15,17 C15.553,17 16,16.552 16,16 L16,6 C16,5.447 15.553,5 15,5 Z M11.88,7 L8,9.771 L4.12,7 L11.88,7 Z M14,15 L2,15 L2,7.943 L7.419,11.813 L7.43,11.799 C7.593,11.916 7.783,12 8,12 C8.217,12 8.407,11.916 8.57,11.799 L8.580999,11.814 L14,7.943 L14,15 Z",
    id: "Icon_Mail_Gray-16px"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailGray16Px);
export default __webpack_public_path__ + "static/media/Icon_Mail_Gray-16px.8be7c4ef0b81bd7ad10ccbb158809510.svg";
export { ForwardRef as ReactComponent };